<template>
    <section class="pb-10 md:pb-20">
        <div class="relative">
            <div class="absolute top-0 left-0 w-full h-full">
                <nuxt-img :src="backgroundImageSrc" sizes="100vw" loading="lazy" width="1920" height="1018"
                    :alt="backgroundImageAlt" format="webp" class="object-cover w-full h-[88%]" />
            </div>

            <div class="relative z-20 px-4 pt-10 mx-auto max-w-5xl lg:pt-20 xl:px-0">
                <div class="flex gap-x-3 justify-center items-center w-full">
                    <span class="w-full h-0.5 bg-white max-w-48">
                    </span>

                    <div class="!leading-none text-white font-ww-bold text-xl  md:text-2xl lg:text-32 -mt-1" v-html="introducingText">
                    </div>

                    <span class="w-full h-0.5 bg-white max-w-48">
                    </span>
                </div>

                <div class="flex flex-wrap gap-x-4 gap-y-4 justify-center py-2 xl:py-4 sm:flex-nowrap">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1580 580" class="w-40" fill="white" v-if="showLogo">
                        <path
                            d="M20.6 10.9C8.8 33.4 2.3 69.5 4.9 98.2c5.8 63.6 40.3 121.7 104.9 176.6 4 3.5 7.7 6 8.2 5.7 1.8-1.1 7-15.6 8.9-25.2 2.6-12.6 2.8-32.8.5-46.4-6-34.9-26.3-70.6-59.1-103.7-10.3-10.4-11.5-11.3-14.5-11-2.8.3-3.4.7-3.6 3.1-.3 2.5 1.4 4.6 12.5 16 30.7 31.5 48.5 62 55 94.5 2.7 13.3 2.4 36.9-.6 48.9-1.2 5.1-2.7 9.3-3.2 9.3-1.9 0-41-39.9-48.9-50-20-25.2-33.8-50.3-42.4-76.5-9.7-29.5-11.3-66.7-4-95.4 2.5-10 8.2-26.1 9.3-26.1 1.1 0 22 16.6 34.2 27 34.6 29.7 63.1 66.4 77.2 99.6 10.4 24.3 14.6 43.5 15.4 69.9.8 30.5-3.7 55.7-15.3 85-11.8 29.6-26 54.2-45.5 78.5-29 36.1-44 62.8-48.5 85.8-1.8 9.5-1.8 13.7.2 15.6 3.9 4 8.4-.1 8.4-7.5 0-19.2 16.2-49.3 48-88.8 6.5-8.1 13.9-17.9 16.4-21.9 2.6-4 4.8-7.2 5-7.2 3.1 0 20-3.8 27.4-6.1 36.8-11.7 62.4-36.9 73.5-72.4 8.4-26.8 8.1-63-.9-100.7-1.4-6.2-3.1-11.9-3.7-12.6-.6-.7-2.1-1.2-3.5-1-4.5.5-4.8 2.6-1.8 15.9 4.1 19.1 5.6 30 6.3 46.9.6 17-.5 29.4-3.8 42.9-8.5 34.3-32.7 60-67.3 71.6-8.2 2.8-20.9 5.6-20.4 4.6.2-.3 3.3-6.5 6.9-13.6 45.9-90.3 36.5-174.7-28.2-251.9C91 57.4 66.1 34.5 39.8 14.9c-16.7-12.4-14.9-12.1-19.2-4z" />
                        <path
                            d="M179.5 74.8c-12.6 3.8-29.9 14.4-31.2 19.1-.4 1.8 0 2.9 1.6 4.2 2.6 2.1 4 1.7 10.1-3 10.8-8.3 27.5-14 36.9-12.6 11.6 1.6 19.9 8.6 27.3 23.1 3.9 7.7 4.6 8.4 7.8 9 17.1 3 50.4 9.4 50.7 9.7.7.7-4.7 1.5-30.7 4.2-23.9 2.5-26 2.9-33 6-10.3 4.6-17.3 6.5-24.3 6.5-5.3 0-6.2-.3-9.2-3.3-5.6-5.6-6.1-17.5-.8-21.7 5.7-4.4 12.5-3.3 14.9 2.6 1.7 4 4.1 5.5 7.2 4.3 1.6-.6 2.2-1.6 2.2-3.9 0-7.5-6.9-14.1-15.5-14.8-6.7-.5-11.3 1-15.5 5.1-4.4 4.3-6.2 8.9-6.2 15.8 0 12.8 5.7 21.5 16 24.5 7.5 2.2 17.1.8 29.1-4.2 11.8-4.9 12.5-5 40.1-8 29.3-3.1 47.1-5.9 51.1-7.9 2.2-1.2 2.9-2.2 2.9-4.6 0-2.4-.6-3.3-3.2-4.4-4.2-1.7-25.6-6.3-51.9-11.1l-20.6-3.8-3.4-6.4c-5.1-9.6-13.7-18.5-21.6-22.4-5.7-2.8-7.8-3.3-15.7-3.5-6.5-.2-10.8.2-15.1 1.5zm769.2 120.3c-34.4 4.6-58 29.2-66.9 69.4-2.5 11.5-3.6 42.1-1.9 54.7 4 29.9 15.4 52.5 33.5 66.2 21 15.9 45.9 20 70.4 11.7 11.8-4.1 18.5-8.4 28.8-18.6 8-8 9.6-10.3 14.7-20.5 9.6-19.5 13.5-40.6 12.4-67.4-1.4-34.7-11-59.6-29.8-77-15.5-14.3-39.2-21.5-61.2-18.5zm25.8 16.4c12 3.2 22.4 10.9 29.4 22 10.3 16.3 14.4 35 14.4 65-.1 27.5-2.9 43.2-10.7 59-7.3 14.9-19 24.4-33.4 27.4-7.5 1.6-23.6 1.3-31.1-.4-24.8-5.9-40.2-29.3-44-66.9-5.6-55.4 12.2-97.2 45-106 7.2-2 23-2 30.4-.1zm149-16.5c-19.5 2.4-36.6 11.7-49.1 26.8-13.7 16.6-21 39.7-22.1 69.7-1.2 32 5.3 58.6 19.1 77.8 20.3 28.5 57.9 39.5 90.6 26.5 20-8 36.2-24.8 44.5-46.3 5.8-14.9 7.6-24.7 8.2-45.2.8-26.3-2-44.3-9.7-62.5-13.8-32.4-46.3-51-81.5-46.8zm25 16.4c23.3 6.2 37.2 24.8 43.1 57.6 2.3 12.8 2.4 45.5.1 59-5.5 32.3-18.9 50.6-41.2 56.5-7.6 1.9-25 1.9-33.3 0-9.3-2.2-16-6-22.9-13.1-14-14.3-20.3-36.8-20.3-72.9 0-25.3 2.5-40.8 9-55.2 7.4-16.4 19.8-27.6 35.1-31.7 6.9-1.9 23.9-2 30.4-.2zm122.7-14.4c-20.8 5.6-34.2 17.8-39.6 35.9-2.1 7.2-2.1 23 0 30.2 5.6 18.9 16.1 27.1 55.7 43.4 25.6 10.6 35.1 19.1 39.3 35.5 3.2 12.6.3 24.8-8.1 33.9-10.1 10.9-20.4 14.6-40.5 14.5-19.4 0-34-3.9-46.7-12.4l-3.3-2.2v5c0 5.9 1.4 7.2 12.4 12.2 12.6 5.8 21.5 7.5 38.6 7.5 14.2-.1 16.2-.3 23.5-2.8 21.1-7.1 36.2-21.9 41-40.2.8-3.3 1.5-9.6 1.5-14 0-15.4-5.1-27.7-15.5-37.3-8.4-7.8-14.4-11.1-34.4-19.2-26.8-10.9-38.3-18.6-44.6-30.2-2.5-4.6-3-6.6-3.3-15.1-.4-9.4-.3-10.1 2.7-16.2 7.1-14.5 23-21.7 44.2-20.1 13.1 1 22 3.6 36.2 10.4.4.2.7-1.9.7-4.8v-5.1l-6.4-2.9c-11.4-5.2-20-7.1-33.6-7.6-10.3-.3-13.8-.1-19.8 1.6zm-520.4 3.7-7.8.4V394h28c15.5 0 32.4-.5 37.7-1.1 18.9-2.1 36.3-8.7 46.4-17.8 15.1-13.5 19.3-38.1 9.7-58-5-10.4-18.8-20-34.8-24-5.7-1.5-7-2.1-5.5-2.7 18-6.7 30.1-17.3 35.6-31.1 1.9-4.8 2.3-7.7 2.4-16.8 0-9.4-.3-11.7-2.4-16.2-3-6.8-11.3-14.6-19.5-18.4-12.2-5.7-21.7-7-53.6-7.3-15.7-.2-32-.1-36.2.1zm66.7 12.7c16.3 4.5 23.3 15.4 22.3 34.7-.9 17.5-9.5 28.5-26.9 34.3-8.7 2.9-22.6 4.6-37.4 4.6H765v-76.2l23.3.5c17.3.3 24.7.9 29.2 2.1zm-4.3 86.4c23.9 6.4 35 21.6 33.5 46.2-.7 11.9-2.9 17.3-9.6 24.1-9.8 9.7-22.8 12.9-53.2 12.9H765v-86.3l20.3.6c15.8.4 21.8.9 27.9 2.5zM1516 203c0 2.9.1 3 5 3h5v26h7v-26h5c4.9 0 5-.1 5-3v-3h-27v3zm31 12.9V232h6.9l.3-8.1.3-8.1 3.4 4.6c1.9 2.5 4 4.6 4.5 4.6.6 0 3-2.1 5.3-4.7l4.2-4.8.1 8.2v8.3h6v-16c0-9.9-.4-16-1-16-.5 0-4 3.8-7.6 8.5l-6.7 8.5-6.4-8.3c-3.5-4.5-7.1-8.3-7.9-8.5-1.2-.3-1.4 2.2-1.4 15.7zM294 297.5V394h99v-11h-77V201h-22v96.5zm134 0V394h22V201h-22v96.5zm62 0V394h22v-96h68v-10l-33.7-.2-33.8-.3-.3-38.3-.2-38.2h76v-10h-98v96.5zm126 0V394h98v-11h-76v-85h68v-10h-68v-77h76v-10h-98v96.5zm737-91.5v5h59v183h22V211h60v-10h-141v5zM844.5 489.4c-6.9 3.1-9.5 8.9-9.5 21.2v8.4h-8v8h8v48h9v-48h14v-8h-14v-8.6c0-8.1.1-8.7 2.9-11.5 2.6-2.5 3.7-2.9 8.6-2.9h5.6l-.3-3.8-.3-3.7-6.5-.2c-3.8-.2-7.7.3-9.5 1.1zm43 0c-6.9 3.1-9.5 8.9-9.5 21.2v8.4h-8v8h8v48h9v-48h14v-8h-14v-8.6c0-8.1.1-8.7 2.9-11.5 2.6-2.5 3.7-2.9 8.6-2.9h5.6l-.3-3.8-.3-3.7-6.5-.2c-3.8-.2-7.7.3-9.5 1.1zm-194.1 30.4c-19.6 6.8-25.7 31.6-11.7 47.2 10.7 11.9 30.5 12.7 41.3 1.5 2.8-2.9 3.1-3.6 2-5-3.1-3.7-5-3.9-8.4-.7-4.5 4.3-6.8 5.2-13.3 5.2-10.8 0-18.9-7.4-20-18.2-.7-6.8.8-11.7 5-16.5 7.7-8.8 19.4-9.6 28.3-1.9l4 3.5 3-2.4 2.9-2.4-4-4c-7.2-7.5-18.6-9.9-29.1-6.3zm73.8 0c-11.2 4-18.1 13.2-19 25.1-2.3 32.7 42 44 55.6 14.2 4.8-10.4 2.9-22.7-4.7-31.4-7.2-8.2-21.3-11.7-31.9-7.9zm21.2 9.9c5.9 4.2 8.6 9.4 8.6 17.1 0 7.8-1.6 11.7-6.8 16.4-4.5 4.1-8.8 5.3-16.3 4.6-13.7-1.3-21.1-17.6-14.1-30.9 2.2-4.3 3.8-5.9 8.2-8.2 4.7-2.5 6.3-2.8 10.9-2.3 3.8.3 6.8 1.4 9.5 3.3zm149.8-9.9c-7.4 2.7-12.5 7.4-16.3 15.2-3.2 6.5-3.2 17.6 0 24.7 5.7 12.7 20.5 19.5 34.4 15.8 5.5-1.4 14.7-6.7 14.7-8.3-.1-.4-1.1-2-2.4-3.5-2.2-2.8-2.2-2.8-4.7-.9-9.2 7.2-23.5 7-30-.4-2.4-2.8-4.9-8-4.9-10.4 0-2 .5-2 22-2h22v-6.5c0-3.7-.7-8.2-1.6-10.3-5-12-20-18.1-33.2-13.4zm17.8 8.5c4.5 2.3 8 7.4 8 11.4v2.3h-17.5c-13.7 0-17.5-.3-17.5-1.3 0-.7 1.3-3.3 2.9-5.8 5.3-8.4 15.5-11.2 24.1-6.6zm59.6-8.7c-6.7 2.1-14.7 10.2-17 17.2-5.9 17.7 2.8 34.3 20.5 38.8 7.7 2 16.2.7 22.8-3.3 6.3-4 7.1-5.6 4.2-8.7l-2.3-2.4-4.5 3.1c-3.8 2.7-5.5 3.2-11.8 3.5-6.6.4-8 .1-11.9-2.2-4.8-2.8-8.2-7.4-9.2-12.5l-.6-3.1h44.1l.6-3.4c1-5.3-1.2-14.1-4.8-18.8-6.3-8.2-19.1-11.7-30.1-8.2zm17.4 8.6c4.5 2.3 7.2 5.9 8.4 11l.6 2.8h-36l1.5-3.7c2.1-5 5.2-8.2 10-10.4 5.4-2.5 10.2-2.4 15.5.3z" />
                    </svg>

                    <div class="text-6xl tracking-tighter text-white xl:text-8xl lg:text-7xl font-ww-bold" v-html="brandName">
                    </div>
                </div>

                <div class="mt-2 text-lg text-center text-white sm:text-xl md:text-2xl xl:text-3xl font-ww-bold" v-html="tagline">
                </div>

                <div class="pt-8 lg:pt-16">
                <nuxt-img :src="productImageSrc" sizes="xs:293px sm:393px md:719px lg:988px xl:988" loading="lazy" width="988"
                    height="633" :alt="productImageAlt" format="webp" class="" />
            </div>
            </div>
        </div>
    </section>
</template>

<script setup>
defineProps({
  backgroundImageSrc: {
    type: String,
    default: '/assets/images/bg-mindflow-1.jpg'
  },
  backgroundImageAlt: {
    type: String,
    default: 'hero background'
  },
  introducingText: {
    type: String,
    default: 'Introducing'
  },
  showLogo: {
    type: Boolean,
    default: true
  },
  brandName: {
    type: String,
    default: 'MINDFLOW'
  },
  tagline: {
    type: String,
    default: 'A Remarkable Breakthrough For All-Day Focused Energy.'
  },
  productImageSrc: {
    type: String,
    default: '/assets/images/mindlfow-2-bottom.png'
  },
  productImageAlt: {
    type: String,
    default: 'Mindflow Product'
  }
})

defineBuilderComponent({
    friendlyName: 'Text Insight With Image Hero',
    canHaveChildren: false,
    inputs: [
        {
            name: 'backgroundImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/bg-mindflow-1.jpg'
        },
        {
            name: 'backgroundImageAlt',
            type: 'text',
            defaultValue: 'hero background'
        },
        {
            name: 'introducingText',
            type: 'richText',
            defaultValue: 'Introducing'
        },
        {
            name: 'showLogo',
            type: 'boolean',
            defaultValue: true
        },
        {
            name: 'brandName',
            type: 'richText',
            defaultValue: 'MINDFLOW'
        },
        {
            name: 'tagline',
            type: 'richText',
            defaultValue: 'A Remarkable Breakthrough For All-Day Focused Energy.'
        },
        {
            name: 'productImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/mindlfow-2-bottom.png'
        },
        {
            name: 'productImageAlt',
            type: 'text',
            defaultValue: 'Mindflow Product'
        }
    ]
})
</script>